const dateFormat = {year: 'numeric', month: 'short', day: 'numeric'};
const dateLocale = 'en-US';

const product_all = "all";
const product_splunk = "splunk";
const product_soar = "soar";
const fips_compatibility = "fips_compatibility";
const splunk_built = "built";
const splunk_supported = "supported";
const includeParam = "include=icon";

const productFilters = ['product', 'product_types', 'soar_product_types'];
const productsArr = [product_splunk, product_soar];

const productMap = {
    "all": product_all,
    "enterprise": product_splunk,
    "cloud": product_splunk,
    "es": product_splunk,
    "itsi": product_splunk,
    "soar_on_prem": product_soar,
    "soar_cloud": product_soar,
}

const allTitle = document.querySelector("#all-title");
const splunkTitle = document.querySelector("#splunk-title");
const soarTitle = document.querySelector("#soar-title");

// Splunk-only filters
const splunkTechnologies = document.querySelector("#splunk-technologies");
const splunkAppType = document.querySelector("#splunk-app-type");
const splunkAppContents = document.querySelector("#splunk-app-contents");
const splunkVersion = document.querySelector("#splunk-version");
const splunkCimVersion = document.querySelector("#splunk-cim-version");
const splunkValidations = document.querySelector("#splunk-validations");
const splunkBuild = document.querySelector("#splunk-build-other")

const splunkDividers = document.querySelectorAll(".splunk-divider");
const soarDivider = document.querySelector(".soar-divider");

// UI: handle show/hide filters and dividers
function showSplunkFilters () {
    if (splunkTechnologies) splunkTechnologies.classList.remove("hide");
    if (splunkAppType) splunkAppType.classList.remove("hide");
    if (splunkAppContents) splunkAppContents.classList.remove("hide");
    if (splunkVersion) splunkVersion.classList.remove("hide");
    if (splunkCimVersion) splunkCimVersion.classList.remove("hide");
    if (splunkValidations) splunkValidations.classList.remove("hide");
    if (splunkBuild) splunkBuild.classList.remove("hide");

    for (let divider of splunkDividers){
        if (divider.classList.contains("hide"))
            divider.classList.remove("hide");
    }
}
function hideSplunkFilters () {
    if (splunkTechnologies) splunkTechnologies.classList.add("hide");
    if (splunkAppType) splunkAppType.classList.add("hide");
    if (splunkAppContents) splunkAppContents.classList.add("hide");
    if (splunkVersion) splunkVersion.classList.add("hide");
    if (splunkCimVersion) splunkCimVersion.classList.add("hide");
    if (splunkValidations) splunkValidations.classList.add("hide");
    if (splunkBuild) splunkBuild.classList.add("hide");

    for (let divider of splunkDividers){
        if (!divider.classList.contains("hide"))
            divider.classList.add("hide");
    }
}
function showSoarFilter () {
    if (soarDivider) soarDivider.classList.remove("hide");
}
function hideSoarFilters () {
    if (soarDivider) soarDivider.classList.add("hide");
}

// UI: select Products and handle filters
const updateUI = {
    allProductsSelected: () => {
        if (splunkTitle) splunkTitle.classList.remove("active");
        if (soarTitle) soarTitle.classList.remove("active");
        if (allTitle) allTitle.classList.add("active");

        hideSplunkFilters();
        hideSoarFilters();
    },
    splunkProductsSelected: () => {
        if (splunkTitle) splunkTitle.classList.add("active");
        if (soarTitle) soarTitle.classList.remove("active");
        if (allTitle) allTitle.classList.remove("active");

        hideSoarFilters();
        showSplunkFilters();
    },
    soarProductsSelected: () => {
        if (soarTitle) soarTitle.classList.add("active");
        if (splunkTitle) splunkTitle.classList.remove("active");
        if (allTitle) allTitle.classList.remove("active");

        hideSplunkFilters();
        showSoarFilter();
    }
};

function uncheckAllSubFilters (self) {
    const filters = self.$get('filters')
    for (let filter in filters){
        if (filter !== "product") {
            let subCatCount = Object.keys(filters[filter]).length;
        
            if (subCatCount > 0) {
                self.$set(`filters|${filter}`, {});
            }
        }
    }
}

function selectFilterItem (self, filterType, productTypeFilterName) {
    if (!productFilters.includes(filterType)) { // for everything but the productFilters
        self.$set(`filters|${filterType}|${productTypeFilterName}`, true);
    } else { // productFilters
        const productTypeFilterParent = productMap[productTypeFilterName];
        const products = self.$get('filters')['product'];
        for (let key in products) {
            if (key !== productTypeFilterParent && products[key]) {
                // switch between products
                self.$set(`filters|product|${key}`, false);
                uncheckAllSubFilters(self);
            }
        }
        self.$set(`filters|product|${productTypeFilterParent}`, true);
        updateUI[productTypeFilterParent+'ProductsSelected']();

        if (productsArr.includes(productTypeFilterParent)) // soar or splunk
            self.$set(`filters|${filterType}|${productTypeFilterName}`, true);
    }
    self.offset = 0;
    self.$callApi();
    self.$buildUrl();
}

function unselectFilterItem (self, filterType, productTypeFilterName) {
    if (!productFilters.includes(filterType)) { // everything but the productFilters
        self.$set(`filters|${filterType}|${productTypeFilterName}`, false);
    } else {
        const productTypeFilterParent = productMap[productTypeFilterName];
        let solutionCount = 0;

        if (productsArr.includes(productTypeFilterParent)) { // soar or splunk
            const product_types_obj = self.$get("filters")[filterType];
            for (let key in product_types_obj) {
                solutionCount = product_types_obj[key] ? solutionCount+1 : solutionCount;
            }
        }
        if (!productTypeFilterParent || solutionCount === 1) {
            uncheckAllSubFilters(self);
            self.$set(`filters|product|all`, true);
            self.$set(`filters|product|${productTypeFilterParent || productTypeFilterName}`, false);
            updateUI['allProductsSelected']();
        } else if (productTypeFilterParent === product_all) {
            uncheckAllSubFilters(self);
            self.$set(`filters|product|all`, false);
            allTitle.classList.remove("active");
        } else {
            self.$set(`filters|${filterType}|${productTypeFilterName}`, false);
        }
    }
    self.offset = 0;
    self.$callApi();
    self.$buildUrl();
}

// sb-search-storage-v2-1
sb.SearchStorageV2 = class extends u.Storage {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
        localStorage.clear();
    }

    attachedCallback() {
        super.attachedCallback();

        this._lastQuery = '';
        this.isRefreshDisabled = false;
        this.offset = 0;

        this.$set('results', []);
        this.$set('viewType', 'simple');

        this.$listen('search', this.$changeFilter.bind(this));
        this.$listen('order', this.$changeFilter.bind(this));

        window.addEventListener('hashchange', this.$parseURL.bind(this));
        sb.SearchStorageV2.instances.push(this);
    }

    $callApi() {
        if (!this.isRefreshDisabled) {
            const queries = this.$buildQuery();
            this._lastQuery = queries.queryString;
            const resultString = localStorage.getItem(queries.queryString);

            if (resultString) {
                const result = JSON.parse(resultString);
                this.$set('results', result);
                this.offset = result.last;
                this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
            }

            else {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v2/apps/?${includeParam}&${queries.queryString}`);
                xhr.onload = () => {
                    if (xhr.readyState === 4 && queries.queryString === this._lastQuery) {
                        const result = JSON.parse(xhr.responseText);
                        // calculate X in "Showing 1-X of Y results"
                        if ((result.offset + result.limit) > result.total) {
                            result.last = result.total; // this is the last page of results
                        } else {
                            result.last = result.offset + result.limit; // there are more results after this page
                        }
                        this.$set('results', result);
                        localStorage.setItem(queries.queryString, JSON.stringify(result));
                        this.offset = result.last;
                        this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
                    }
                };
                xhr.send();
            }
        }
    }

    $changeFilter() {
        if (!this.isRefreshDisabled) {
            this.offset = 0;
            this.$callApi();
            this.$buildUrl();
        }
    }

    $loadMore() {
        this.$enableRefresh();
        this.$callApi();
    }

    $disableRefresh() {
        this.isRefreshDisabled = true;
    }

    $enableRefresh() {
        this.isRefreshDisabled = false;
    }

    $sendGoogleAnalytics(queries, offset, total) {
        // Only send under certain circumstances...
        // offset === 0: this is the first search - not subsequent searches due to pagination
        // "search" in queries: user searched for a string. Don't send if they just used filters with no search string
        if (offset === 0 && "search" in queries) {
            // sort queries by key ("search", "products", etc) so it's organized properly in google analytics
            let sorted = [];
            for (let key in queries) {
                sorted[sorted.length] = key;
            }
            sorted.sort();

            // put the sorted queries into a human readable string
            let searchParams = [];
            for (let key in sorted) {
                searchParams.push(sorted[key] + '=' + queries[sorted[key]]);
            }
            const joined_params = searchParams.join(', ');
            _gaq.push(['_trackEvent', 'Search', 'apps', joined_params, total]);
        }
    }

    $parseURL() {
        /**
         * when a page is first loaded or the url changes, we must parse the URL to pre-fill the filters
         * based on the fragment
         *
         * TODO(bchoi): change the frag to browser history in the future
         */

        // this.$set() fires callapi. We want to fire callApi when we are all done loading the filters based on
        // the url fragments
        this.$disableRefresh();

        this.$clearFilters();
        const hashes = window.location.hash.split('/');
        let productValue;

        for (let i = 1; i < hashes.length; i += 2) {
            let filterType = hashes[i],
                value = decodeURIComponent(hashes[i + 1]);
            // Escape value to prevent XSS
            value = value.replace(/&/g, '').replace(/</g, '').replace(/>/g, '').replace(/"/g, '').replace(/'/g, '').replace(/\//g, '');
            
            if (filterType && value) {
                if (filterType in this.$get('filters')) {
                    let values = value.split(',');
                    for (let value of values) {
                        this.$set('filters|' + filterType + '|' + value, true);
                        if (filterType === "product"){
                            productValue = value;
                            updateUI[productValue+'ProductsSelected']();
                        }
                    }
                } else {
                    this.$set(filterType, value, true);
                }
            }
        }
        this.$enableRefresh();

        // display All Products if url doesn't contain a query.
        if (!productValue)
            selectFilterItem(this, "product", product_all);
        else {
            this.offset = 0;
            this.$callApi();
        }
    }

    $buildQuery() {
        let queries = [];
        let loggedQueries = {}; // for google analytics

        const search = this.$get('search');
        let order = this.$get('order');
        let options = {};

        options.relevance = document.getElementById('sortrelevance'); 
        options.latest = document.getElementById('sortlatest');
        options.popular = document.getElementById('sortpopular');

        queries.push(`offset=${this.offset}`);

        options.relevance.removeAttribute('selected');
        options.latest.removeAttribute('selected');
        options.popular.removeAttribute('selected');

        // if keyword search is in place, we need to take care of some logistics
        if (search) {
            // If there's a search, enable/show the relevance sort option
            options.relevance.disabled = false;
            options.relevance.classList.remove("u.hide@*");

            queries.push(`query=${search}`);
            loggedQueries['search'] = search.toLowerCase();

            // if no order is selected, go with relevance order by default
            if (!order) {
                queries.push('order=relevance');
                options.relevance.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
        } else {

            // If there's no search, disable/hide the relevance sort option
            // this won't hide it in all browsers, hence disabling too
            options.relevance.classList.add("u.hide@*"); 
            options.relevance.disabled = true;

            // if no order is selected, go with newest order by default
            if (!order) {
                queries.push('order=latest');
                options.latest.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
            if (this.isArchive) {
                options.latest.selected = false;
                options.popular.selected = true;
                queries.push('order=popular');
            }
        }

        if (this.isArchive) {
            queries.push('archive=true');
        }else{
            queries.push('archive=false');
        }

        const obj = this.$get('filters');
        for (let filter in obj) {
            let filters = [];
            for (let item in obj[filter]) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                if (filter == "validation" || filter == "status") {
                    for (let ele of filters) {
                        if (ele == fips_compatibility) {
                            queries.push(`${ele}=true`);
                            loggedQueries[ele] = "true";
                        }
                        if (ele == splunk_built) {
                            queries.push("created_by=splunk");
                            loggedQueries["created_by"] = "splunk";
                        }
                        if (ele == splunk_supported) {
                            queries.push("support=splunk");
                            loggedQueries["support"] = "splunk";
                        }
                    }
                } else if (filter == 'author') {
                    queries.push(`created_by=${filters.join(',')}`)
                    loggedQueries['created_by'] = filters.join(',');
                } else if (filter == 'soar_product_types') { // soar product type params/values are different in the api
                    // in the API the soar on-prem product type is just called "soar", so we have to rename it
                    for (let i = 0; i < filters.length; i++) {
                        if (filters[i] == 'soar_on_prem') {
                            filters[i] = 'soar';
                            break;
                        }
                    }
                    queries.push(`product_types=${filters.join(',')}`)
                } else {
                    queries.push(`${filter}=${filters.join(',')}`)
                    loggedQueries[filter] = filters.join(',');
                }
            }
        }

        return {queryString:queries.join('&'), loggedQueries:loggedQueries};
    }

    $buildUrl() {
        let params = [];

        const order = this.$get('order');
        if(order) {
            params.push(`order/${order}`);
        }

        const search = this.$get('search');
        if (search) {
            // URL encode the search keywords
            const uriSearch = encodeURI(search);
            // put the search keywords into the URL
            params.push(`search/${uriSearch}`);
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                params.push(`${filter}/${filters.join(',')}`)
            }
        }
        history.pushState(null, null, '#/' + params.join('/'));
    }
    
    $clearFilters() {
        this.$set('filters', {});
        this.$set('filters|product', {});
        this.$set('filters|product_types', {});
        this.$set('filters|soar_product_types', {});
        this.$set('filters|categories', {});
        this.$set('filters|technology', {});
        this.$set('filters|app_type', {});
        this.$set('filters|content', {});
        this.$set('filters|versions', {});
        this.$set('filters|cim_versions', {});
        this.$set('filters|status', {});
        this.$set('filters|author', {});
        this.$set('filters|archive', {});
        this.$set('filters|validation', {});
        this.$set('order', '');
        this.$set('search', '');
        this.$set('offset', 0);
    }
}

sb.SearchStorageV2.instances = [];
sb.SearchStorageV2.register('sb-search-storage-v2-1');


// sb-search-toggle-v2-1
u.SearchToggle = class extends u.BaseElement {
    attachedCallback() {
        const group = this.getAttribute('group');
        if (!u.SearchToggle.groups.hasOwnProperty(group)) {
            u.SearchToggle.groups[group] = [];
        }

        u.SearchToggle.groups[group].push(this);

        super.attachedCallback();
        this.addEventListener('click', () => {
            this.classList.toggle('open');
            for (let toggle of u.SearchToggle.groups[group]) {
                if (toggle !== this) {
                    toggle.classList.remove('open');
                }
            }
        });
    }
};
u.SearchToggle.groups = {};
u.SearchToggle.register('sb-search-toggle-v2-1');

// sb-filter-count-v2-1
(class extends u.Bind {
    $onChange(value) {
        let count = 0;
        for (let key of Object.keys(value)) {
            if (value[key]) {
                count++;
            }
        }

        if (count) {
            this.textContent = count;
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }
}).register('sb-filter-count-v2-1');

// sb-search-checkbox-v2-1
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.searchfield = this.getAttribute('searchfield');
        if (this.searchfield !== null) {
            this.searchfield = this.getAttribute('searchfield');
            this.parentPath = `filters|${this.searchfield}`;
        } else {
            this.parentPath = `filters|${this.name}`;
        }
        this.path = `${this.parentPath}|${this.value}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));
        this.$storage.$listen(this.parentPath, this.$onClear.bind(this));

        this.addEventListener('change', () => {
            if (this.checked)
                selectFilterItem(this.$storage, this.name, this.value);
            else 
                unselectFilterItem(this.$storage, this.name, this.value);
        });
    }

    $onChange(value) {
        this.checked = value;
    }

    // when filters are being cleared, we need to make sure all of checkboxes get cleared too.
    $onClear(value) {
        if (Object.keys(value).length === 0) {
            this.checked = false;
        }
    }
}).register('sb-search-checkbox-v2-1');

// sb-search-pill-v2-1
u.SbSearchPill = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();

        // canonical to display name map filled by sb-search-pill-map
        this.map = {};
        this.name = this.getAttribute('name');
    }

    $name(value) {
        // if the mapping exists, use it otherwise return the value as is
        if (value in this.map) {
            return this.map[value];
        }
        return value;
    }

    $onChange(value) {
        this.innerHTML = '';

        if (!value || value === undefined || value.length === 0) {
            return;
        }

        const self = this;
        const filters = [];

        if (typeof(value) === 'object') {
            for (let filter of Object.keys(value)) {
                if (value[filter]) {
                    filters.push({
                        name: this.$name(filter),
                        path: self.bindTo + "|" + filter
                    });
                }
            }
        } else {
            filters.push({
                name: this.$name(value),
                path: self.bindTo
            });
        }

        for (let filter of filters) {
            const button = document.createElement('button');
            button.className = "u.btn u.item c-search-pill";
            button.addEventListener('click', ()=> {
                self.$onRemove(filter.path);
            });

            const nameSpan = document.createElement('span');
            nameSpan.innerHTML = `${this.name}: `;

            // name:
            button.appendChild(nameSpan);

            const span = document.createElement('span');
            span.innerHTML = filter.name;

            const remove = document.createElement('span');
            remove.className = 'remove';
            remove.innerHTML = "<svg class='u.icon:tiny sb.color:gray-dark c-search-pill__close'><use xlink:href='#close-x'/></svg>";

            button.appendChild(span);
            button.appendChild(remove);
            this.appendChild(button);
        }
    }

    $onRemove(path) {
        if (path === 'search')
            this.$storage.$unset(path);
        else
            unselectFilterItem(this.$storage, path.split('|')[1], path.split('|')[2]);
    }
};
u.SbSearchPill.register('sb-search-pill-v2-1');

// sb-bind-v2-1
u.SbBind = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        super.$onChange(value[this.$key]);
    }
};
u.SbBind.register('sb-bind-v2-1');

// sb-results-v2-1
(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        // message for no results returned
        const no_results = document.querySelector('p[is=sb-no-results]');
        // hide sort select if no results returned
        const sort_select = document.querySelector('select[is=order-select-v2-1]');

        if (value[this.$key] > 0) {
            no_results.classList.add('u.hide@*');
            sort_select.classList.remove('u.hide@*');
            this.classList.remove('u.hide@*');
        } else {
            no_results.classList.remove('u.hide@*');
            sort_select.classList.add('u.hide@*');
            this.classList.add('u.hide@*');
        }
    }
}).register('sb-results-v2-1');

// sb-search-input-v2-1
// TODO is this used?
// (class extends u.ConsumerInput {
//     attachedCallback() {
//         super.attachedCallback();
//         this.addEventListener('change', ()=> {
//             if (this.value) {
//                 this.$storage.$set('search', this.value);
//             } else {
//                 this.$storage.$set('search', '');
//             }
//         });
//     }
// }).register('sb-search-input-v2-1');

// sb-archive-search-input-v2-1
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-archive-search-input-v2-1');

// order-select-v2-1
(class extends u.ConsumerSelect {
    attachedCallback() {
        super.attachedCallback();

        this.path = `${this.name}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', ()=> {
            this.$storage.$set('order', this.value);
        });
    }

    $onChange(value) {
        this.value = value;
    }
}).register('order-select-v2-1');

// sb-view-toggle-v2-1
// toggle for details vs. simple view
sb.SearchViewToggle = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();

        this.viewType = this.getAttribute('type');
        sb.SearchViewToggle.items.push(this);

        this.addEventListener('click', ()=> {
            this.$storage.$set('viewType', this.viewType);

            // update button colors
            for (let i = 0; i < sb.SearchViewToggle.items.length; i++) {
                if (sb.SearchViewToggle.items[i].getAttribute('type') === this.viewType) {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.add('active');
                } else {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.remove('active');
                }
            }
        });
    }
};
sb.SearchViewToggle.items = [];
sb.SearchViewToggle.register('sb-view-toggle-v2-1');

// sb-app-card-v2-1
sb.AppCard = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.type = this.getAttribute('type');
        this.$storage.$listen('viewType', this.$onChange.bind(this))

        // toggle based on the initial state when being added
        this.$onChange(this.$storage.$get('viewType'));
    }

    $onChange(value) {
        if(this.type === value) {
            this.classList.remove("u.hide@*");
        } else {
            this.classList.add("u.hide@*");
        }
    }
};
sb.AppCard.register('sb-app-card-v2-1');
sb.AppCard.appCardsDetailed = [];
sb.AppCard.appCardsSimple = [];


// sb-search-pill-map-v2-1
(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.parentNode.map[this.getAttribute('canonical_name')] = this.getAttribute('display_name');
    }
}).register('sb-search-pill-map-v2-1');

// sb-search-results-v2-1
(class extends u.Bind {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();
    }

    $onChange(value) {
        if (!value.results || value.results.length === 0) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');

            const appCards = [];
            for (let app of value.results) {
                const published_date = new Date(Date.parse(app.published_time)).toLocaleDateString(dateLocale, dateFormat);
                const updated_date = new Date(Date.parse(app.updated_time)).toLocaleDateString(dateLocale, dateFormat);

                // Create the detailed app card
                const appCardDetailed = document.createElement('sb-app-card-v2-1');
                appCardDetailed.className = "u.item:1/1@* sb.app-card";
                appCardDetailed.setAttribute("type", "detailed");
                let product_name = '';
                if (app.product_compatibility == 'soar') {
                    product_name = 'Splunk SOAR'
                } else if (app.product_compatibility == 'splunk') {
                    product_name = 'Splunk'
                }
                appCardDetailed.innerHTML = `
                        <a href="/app/${app.id}">
                            <div class="u.container:top@* u.container:pad-little">
                                <img class="c-search-icon u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                <div class="u.item:grow@*" style="width:70%;">
                                    <div class="u.container">
                                        <div class="u.item:1/1@*">
                                            <div class="u.container">
                                                <h6 class="u.item">${app.app_name}</h6>
                                                <div class="u.item:hspace-sm" data-tooltip="${product_name} Cloud" style="display:${app.cloud_compatible ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-cloud"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-built"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-labs"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="u.item:1/1@*"><p class="sb.wrap sb.clamp:3x">${app.description}</p></div>
                                        <div class="u.item:1/1@*">
                                            <div class="u.container:nowrap@md-up u.container:vspace-xs@sm c-search-details-footer">
                                                <div class="u.item:1/1@sm">Released: ${published_date}</div>
                                                <div class="u.item u.hide@sm"> | </div>
                                                <div class="u.item:1/1@sm">Updated: ${updated_date}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="u.item u.btn:wide@xs sb.pill-tag no-hover ${app.product_compatibility} search-page-detail-view">${app.product_compatibility}</div>
                            </div>
                        </a>
                `;
                appCards.push(appCardDetailed);

                // Create the simple app card
                const appCardSimple = document.createElement('sb-app-card-v2-1');
                if (this.isArchive) {
                    appCardSimple.className = "u.item:tall@* u.item:2/12@lg-up u.item:6/12@md-down sb.app-card";
                }else{
                    appCardSimple.className = "u.item:tall@* u.item:3/12@lg-up u.item:6/12@md-down sb.app-card";
                }
                appCardSimple.setAttribute("type", "simple");
                appCardSimple.innerHTML = `
                        <a href="/app/${app.id}">
                          <div class="u.container:pad-little">
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:top@*">
                                    <img class="u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                    <div class="u.item u.btn:wide@xs sb.pill-tag no-hover ${app.product_compatibility}">${app.product_compatibility}</div>
                                </div>
                            </div>
                            <div class="u.item:1/1@*">
                                <h6 class="sb.clamp:heading-2x">${app.app_name}</h6>
                            </div>
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:middle@*">
                                    <div class="u.item">
                                        <div class="u.container">
                                            <div class="u.item:hspace-sm" data-tooltip="${product_name} Cloud" style="display:${app.cloud_compatible ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-cloud"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-built"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-labs"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </a>
                `;
                appCards.push(appCardSimple);
            }
            if (value.offset === 0) {
                this.innerHTML = '';
            }

            
            for(let appCard of appCards) {
                this.appendChild(appCard);
            }
        }
    }
}).register('sb-search-results-v2-1');

// sb-search-loadmore-v2-1
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        const button = this.querySelector('div[id="loadmore"]');
        button.addEventListener('click', this.clickfunc.bind(this));
        this.$storage.$listen('results', this.$onChange.bind(this));
    }

    clickfunc(evt) {
        evt.preventDefault();
        this.$storage.$loadMore();
    }

    $onChange(value) {
        if (value.last === value.total) {
            this.classList.add('u.hide@*');
            //click event is removed to prevent a bug from occuring
            //this.removeEventListener('click', this.clickfunc);
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-loadmore-v2-1');

// sb-search-feedback-container-v2-1
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen('results', this.$onChange.bind(this));
    }
    $onChange(value) {
        if (value.last !== value.total) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-feedback-container-v2-1');


// sb-search-suggestion-v2-1
(class extends u.SbBind {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('click', (evt)=> {
            evt.preventDefault();
            window.location = `/apps/#/search/${this.value}`;
        });
    }

    $onChange(value) {
        this.value = value[this.$key];
        if (this.value) {
            this.classList.remove('u.hide@*');
            this.textContent = `Show Results for "${this.value}" Instead`;
        } else {
            this.classList.add('u.hide@*');
            this.textContent = null;
        }
    }
}).register('sb-search-suggestion-v2-1');

// sb-search-feedback-v2-1
//search feedback form processing
(class extends u.ModalForm {
    attachedCallback() {
        super.attachedCallback();
        this.$findStorage();
    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        xhr.open('POST', '/api/v0/searchfeedback/');
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());

        const formData = new FormData(this);
        formData.append('category', Object.keys(this.$storage.$get('filters|category')).join(', '));
        formData.append('search', this.$storage.$get('search'));
        formData.append('versions', Object.keys(this.$storage.$get('filters|version')).join(', '));
        formData.append('type', Object.keys(this.$storage.$get('filters|type')).join(', '));
        formData.append('cims', Object.keys(this.$storage.$get('filters|cim')).join(', '));
        formData.append('results', this.$storage.$get('results').total);

        xhr.send(formData);
    }

    $closeModal() {
        window.location.reload(false);
    }

    $findStorage() {
        // hacky but better than trying to use multi-inheritance hack
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }
    }
}).register('sb-search-feedback-v2-1');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.SearchStorageV2.instances) {
        instance.$parseURL();
    }
});